<script>
import Button from "@/components/ui/Button.vue";

export default {
    name: "ReserveAirportLocation" ,
    components: {Button}
}
</script>

<template>
    <div class="container mx-auto py-2 px-8 md:px-4 my-20">
        <div class="flex">
            <div class="mr-0 md:mr-32">
                <h1 class="text-4xl font-bold m-0 mb-4">
                    {{ $t('homePage.reserveAirportLocation.title') }}
                </h1>
                <p class="mb-8 text-xl">
                    {{ $t('homePage.reserveAirportLocation.subtitle') }}
                </p>

                <ul class="list-disc list-inside">
                    <li class="text-2xl font-bold mb-4">{{ $t('homePage.reserveAirportLocation.list_1') }}</li>
                    <li class="text-2xl font-bold mb-4">{{ $t('homePage.reserveAirportLocation.list_2') }}</li>
                    <li class="text-2xl font-bold mb-4">{{ $t('homePage.reserveAirportLocation.list_3') }}</li>
                    <li class="text-2xl font-bold mb-8">{{ $t('homePage.reserveAirportLocation.list_4') }}</li>
                </ul>

                <p class="italic text-xl mb-16">
                    {{ $t('homePage.reserveAirportLocation.list_subtitle') }}
                </p>

                <Button
                    :text="$t('homePage.reserveAirportLocation.btn_text')"
                    color="blue"
                    size="lg"
                    @click="$router.push('purchase-rent')"
                    class="hidden xl:flex text-xl"
                >
                    <div>
                        <img loading="lazy" class="" src="@/assets/svg/round-arrow-right.svg" alt="">
                    </div>
                </Button>
            </div>
            <div class="hidden md:block">
                <img src="../../assets/png/ReserveAirportLocation.png" alt="Airport pickup">
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>